<template>
    <div class="grey lighten-3 pa-4 greyContainer">
        <div class="title">ADE / DSV / Ärtzl. Attest</div>
        <v-alert v-if="!selectedSportart" icon="mdi-information" color="white" class="mt-3">
            <div class="mb-2">Bitte wähle eine Sportart:</div>
            <v-btn color="primary" class="mr-10 mb-5" @click="setSportart('Classic')">Classic</v-btn>
            <v-btn color="#5584c4" dark class="mb-5" @click="setSportart('Bowling')">Bowling</v-btn>
        </v-alert>
        <v-card class="mt-2" v-else-if="bestaetigungen">
            <v-card-text>
                <v-alert text icon="mdi-information" color="primary" dense
                         v-if="!bestaetigungen.selectedVerbandId || !bestaetigungen.selectedVereinId">
                    Bitte einen Landesverband und einen Verein wählen!
                </v-alert>
                <v-row no-gutters align="center">
                    <v-col cols="12" sm="6" >
                        <v-autocomplete v-model="bestaetigungen.selectedVerbandId"
                                        :items="bestaetigungen.landesVerbaende"
                                        label="Landesverband wählen" outlined dense item-text="text"
                                        item-value="id" clearable hide-details/>
                    </v-col>
                    <v-col cols="12" sm="6" :class="[{'pl-3': $vuetify.breakpoint.smAndUp},{'mt-5': $vuetify.breakpoint.xsOnly}]">
                        <v-autocomplete v-model="bestaetigungen.selectedVereinId"
                                        :items="vereine" :disabled="!bestaetigungen.selectedVerbandId"
                                        label="Verein wählen" outlined dense clearable hide-details/>
                    </v-col>
                    <v-col cols="12" sm="6" >
                        <v-radio-group v-model="bestaetigungen.geschlecht" row >
                            <v-radio label="Damen" value="f"/>
                            <v-radio label="Herren" value="m"/>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12" sm="6" :class="[{'pl-1 text-right': $vuetify.breakpoint.smAndUp}]">
                        <v-btn v-for="i in bestaetigungen.seiten" :key="i"
                               :class="[{'ml-3': $vuetify.breakpoint.smAndUp},{'my-1': bestaetigungen.seiten>1}]"
                               color="primary" @click="exportToPDF(i)" :block="$vuetify.breakpoint.xsOnly"
                                :disabled="!bestaetigungen.selectedVerbandId || !bestaetigungen.selectedVereinId || spieler===0">
                            <v-icon>mdi-download</v-icon>PDF Export <span v-if="bestaetigungen.seiten>1">(Seite {{i}})</span></v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <bestaetigungen-liste v-if="!bestaetigungen.loading" :bestaetigungen="bestaetigungen"/>
            <div v-else class="pb-1">
                <v-alert text icon="mdi-information" class="ma-5" color="primary">
                    Die Daten werden geladen...
                    <v-progress-linear indeterminate class="mt-2"/>
                </v-alert>
            </div>
        </v-card>
        <bestaetigungen-pdf-vorschau :bestaetigungen="bestaetigungen" :aktuelle-seite="aktuelleSeite"/>
    </div>
</template>

<script>
import {BestaetigungenService} from "@/services/data/bestaetigungen/bestaetigungenService";
import BestaetigungenListe from "@/views/ergebnisdienst/bestaetigungen/bestaetigungenListe";
import BestaetigungenPdfVorschau from "@/views/ergebnisdienst/bestaetigungen/bestaetigungenPDFVorschau";
import RouterServices from "@/utilities/services/router/routerServices";

export default {
    name: "bestaetigungen",
    components: {BestaetigungenPdfVorschau, BestaetigungenListe},
    data: () => ({
        noExported: 0,
        bestaetigungen: null,
        aktuelleSeite: 1,
    }),
    computed: {
        vereine(){return this.bestaetigungen.getVereineFromLV()},
        selectedSportart(){ return this.$route.query.sportart },
        spieler(){ return this.bestaetigungen?.spieler.length ?? 0},
    },
    created(){
        this.init()
    },
    methods: {
        init(){
            this.bestaetigungen = new BestaetigungenService(this.selectedSportart)
        },
        exportToPDF(i){
            this.aktuelleSeite = i
            RouterServices.pushRouteQueryParameter(this.$router, this.$route, 'bestaetigungenPDF', true)
        },
        setSportart(sportart){
            RouterServices.pushRouteQueryParameter(this.$router, this.$route, 'sportart', sportart)
            this.init()
        }
    },
    watch: {
        'bestaetigungen.selectedVerbandId'(){
            this.bestaetigungen.selectedVereinId = null
            this.bestaetigungen.bindLVRealtimeData()
        },
        'bestaetigungen.selectedVereinId'(){
            this.bestaetigungen.loadSpieler()
        },
        'bestaetigungen.geschlecht'(){
            this.bestaetigungen.loadSpieler()
        }
    },
}
</script>

<style scoped>
    .greyContainer{position: fixed; top: 48px; bottom: 0; left: 0; right: 0; overflow-y: scroll}
</style>